import ReCAPTCHA from 'react-google-recaptcha';
import { withProps } from 'recompose';

export const enhance = withProps(({ input }) => ({
	size: 'normal',
	...input,
}));

export default enhance(ReCAPTCHA);
